import { createFeatureSelector } from '@ngrx/store'
import { IActionProgressDialogState } from './action-progress-dialog.reducer'
import { StoreKeysEnum } from '../../../../store/store-keys'

export const selectActionProgressDialogFeature = createFeatureSelector<Readonly<IActionProgressDialogState>>(StoreKeysEnum.ActionProgressDialogComponent)
